import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CTASection from '../components/sections/CTASection';
import SocialProof from '../components/sections/SocialProof';
import { Monitor, School } from 'lucide-react';

export default function TypySkoleniPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>

        {/* Hero */}
        <section className="pt-36 pb-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="inline-flex items-center px-4 py-2 bg-teal-50 border border-teal-100 rounded-full text-teal-700 text-sm font-medium mb-8">
              Financovatelné z OP JAK II
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 leading-tight">
              Jak může školení proběhnout
            </h1>
          </div>
        </section>

        {/* Online */}
        <section className="py-16 bg-slate-50 border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <Monitor className="w-6 h-6 text-teal-600" />
              </div>
              <h2 className="text-3xl font-bold text-slate-900">Online</h2>
            </div>
            <div className="max-w-2xl space-y-5 text-lg text-slate-600 leading-relaxed">
              <p>Lektor vás provede tématem živě.</p>
              <p>
                Online forma není zjednodušená verze školení. Naopak umožňuje{' '}
                <strong className="text-slate-900">jít rychle k věci a rovnou pracovat</strong>.
              </p>
              <p>
                Účastníci sdílí obrazovku, zkoušejí AI v reálném čase a vytvářejí vlastní výstupy.
              </p>
              <div className="space-y-3 pt-2">
                {[
                  'Termíny probíhají několikrát měsíčně — ranní i odpolední.',
                  'Na každém online kurzu se setkávají pedagogové z různých škol po celé ČR.',
                  'Může se zúčastnit i jediný pedagog z vaší školy — nemusíte čekat, až se sejde celý sbor.',
                  'Online kurz není omezen maximálním počtem účastníků.',
                ].map((t, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full bg-teal-500 flex-shrink-0 mt-2.5" />
                    <span>{t}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Prezenčně */}
        <section className="py-16 bg-white border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <School className="w-6 h-6 text-teal-600" />
              </div>
              <h2 className="text-3xl font-bold text-slate-900">Prezenčně</h2>
            </div>
            <div className="max-w-2xl space-y-5 text-lg text-slate-600 leading-relaxed">
              <p>Školení může proběhnout přímo ve vaší škole.</p>
              <p>
                Prezenční forma dává ještě větší prostor{' '}
                <strong className="text-slate-900">společné práci, dotazům a řešení konkrétních situací</strong>{' '}
                vašeho pedagogického týmu.
              </p>
              <div className="space-y-3 pt-2">
                {[
                  'Termín si volíte vy — domlouváme se podle vašich možností.',
                  'Naši lektoři přijedou přímo k vám do školy, kdekoliv v ČR.',
                  'Minimální počet účastníků: 8 pedagogů.',
                ].map((t, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full bg-teal-500 flex-shrink-0 mt-2.5" />
                    <span>{t}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <SocialProof />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
